// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file sticker/sticker_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type { StickerPackEnriched } from './sticker_model_pb';
import { file_sticker_sticker_model } from './sticker_model_pb';

/**
 * Describes the file sticker/sticker_responses.proto.
 */
export const file_sticker_sticker_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch9zdGlja2VyL3N0aWNrZXJfcmVzcG9uc2VzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJiChdHZXRTdGlja2VyUGFja3NSZXNwb25zZRI/CgdzdWNjZXNzGAEgASgLMiwuY29tLmdlbS5iZmYuY29udHJhY3QuR2V0U3RpY2tlclBhY2tzU3VjY2Vzc0gAQgYKBHR5cGUiYQoWR2V0U3RpY2tlclBhY2tzU3VjY2VzcxJHChRzdGlja2VyUGFja3NFbnJpY2hlZBgBIAMoCzIpLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlN0aWNrZXJQYWNrRW5yaWNoZWQifAokR2V0VXNlckluc3RhbGxlZFN0aWNrZXJQYWNrc1Jlc3BvbnNlEkwKB3N1Y2Nlc3MYASABKAsyOS5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRVc2VySW5zdGFsbGVkU3RpY2tlclBhY2tzU3VjY2Vzc0gAQgYKBHR5cGUibgojR2V0VXNlckluc3RhbGxlZFN0aWNrZXJQYWNrc1N1Y2Nlc3MSRwoUc3RpY2tlclBhY2tzRW5yaWNoZWQYASADKAsyKS5jb20uZ2VtLmJmZi5jb250cmFjdC5TdGlja2VyUGFja0VucmljaGVkImgKGkdldFN0aWNrZXJQYWNrQnlJZFJlc3BvbnNlEkIKB3N1Y2Nlc3MYASABKAsyLy5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRTdGlja2VyUGFja0J5SWRTdWNjZXNzSABCBgoEdHlwZSJkChlHZXRTdGlja2VyUGFja0J5SWRTdWNjZXNzEkcKFHN0aWNrZXJQYWNrc0VucmljaGVkGAEgASgLMikuY29tLmdlbS5iZmYuY29udHJhY3QuU3RpY2tlclBhY2tFbnJpY2hlZCJjCh9BZGRTdGlja2VyUGFja1RvUHJvZmlsZVJlc3BvbnNlEjgKB3N1Y2Nlc3MYASABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5Cb29sZWFuUmVzcG9uc2VIAEIGCgR0eXBlImgKJFJlbW92ZVN0aWNrZXJQYWNrRnJvbVByb2ZpbGVSZXNwb25zZRI4CgdzdWNjZXNzGAEgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQm9vbGVhblJlc3BvbnNlSABCBgoEdHlwZUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_sticker_sticker_model, file_common_common_responses]
  );

/**
 * @generated from message com.gem.bff.contract.GetStickerPacksResponse
 */
export type GetStickerPacksResponse = Message<'com.gem.bff.contract.GetStickerPacksResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetStickerPacksResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetStickerPacksSuccess success = 1;
         */
        value: GetStickerPacksSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetStickerPacksResponse.
 * Use `create(GetStickerPacksResponseSchema)` to create a new message.
 */
export const GetStickerPacksResponseSchema: GenMessage<GetStickerPacksResponse> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GetStickerPacksSuccess
 */
export type GetStickerPacksSuccess = Message<'com.gem.bff.contract.GetStickerPacksSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.StickerPackEnriched stickerPacksEnriched = 1;
   */
  stickerPacksEnriched: StickerPackEnriched[];
};

/**
 * Describes the message com.gem.bff.contract.GetStickerPacksSuccess.
 * Use `create(GetStickerPacksSuccessSchema)` to create a new message.
 */
export const GetStickerPacksSuccessSchema: GenMessage<GetStickerPacksSuccess> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 1);

/**
 * @generated from message com.gem.bff.contract.GetUserInstalledStickerPacksResponse
 */
export type GetUserInstalledStickerPacksResponse =
  Message<'com.gem.bff.contract.GetUserInstalledStickerPacksResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetUserInstalledStickerPacksResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetUserInstalledStickerPacksSuccess success = 1;
           */
          value: GetUserInstalledStickerPacksSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetUserInstalledStickerPacksResponse.
 * Use `create(GetUserInstalledStickerPacksResponseSchema)` to create a new message.
 */
export const GetUserInstalledStickerPacksResponseSchema: GenMessage<GetUserInstalledStickerPacksResponse> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 2);

/**
 * @generated from message com.gem.bff.contract.GetUserInstalledStickerPacksSuccess
 */
export type GetUserInstalledStickerPacksSuccess =
  Message<'com.gem.bff.contract.GetUserInstalledStickerPacksSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.StickerPackEnriched stickerPacksEnriched = 1;
     */
    stickerPacksEnriched: StickerPackEnriched[];
  };

/**
 * Describes the message com.gem.bff.contract.GetUserInstalledStickerPacksSuccess.
 * Use `create(GetUserInstalledStickerPacksSuccessSchema)` to create a new message.
 */
export const GetUserInstalledStickerPacksSuccessSchema: GenMessage<GetUserInstalledStickerPacksSuccess> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 3);

/**
 * @generated from message com.gem.bff.contract.GetStickerPackByIdResponse
 */
export type GetStickerPackByIdResponse =
  Message<'com.gem.bff.contract.GetStickerPackByIdResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetStickerPackByIdResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetStickerPackByIdSuccess success = 1;
           */
          value: GetStickerPackByIdSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetStickerPackByIdResponse.
 * Use `create(GetStickerPackByIdResponseSchema)` to create a new message.
 */
export const GetStickerPackByIdResponseSchema: GenMessage<GetStickerPackByIdResponse> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 4);

/**
 * @generated from message com.gem.bff.contract.GetStickerPackByIdSuccess
 */
export type GetStickerPackByIdSuccess =
  Message<'com.gem.bff.contract.GetStickerPackByIdSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.StickerPackEnriched stickerPacksEnriched = 1;
     */
    stickerPacksEnriched?: StickerPackEnriched;
  };

/**
 * Describes the message com.gem.bff.contract.GetStickerPackByIdSuccess.
 * Use `create(GetStickerPackByIdSuccessSchema)` to create a new message.
 */
export const GetStickerPackByIdSuccessSchema: GenMessage<GetStickerPackByIdSuccess> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 5);

/**
 * @generated from message com.gem.bff.contract.AddStickerPackToProfileResponse
 */
export type AddStickerPackToProfileResponse =
  Message<'com.gem.bff.contract.AddStickerPackToProfileResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.AddStickerPackToProfileResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.AddStickerPackToProfileResponse.
 * Use `create(AddStickerPackToProfileResponseSchema)` to create a new message.
 */
export const AddStickerPackToProfileResponseSchema: GenMessage<AddStickerPackToProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 6);

/**
 * @generated from message com.gem.bff.contract.RemoveStickerPackFromProfileResponse
 */
export type RemoveStickerPackFromProfileResponse =
  Message<'com.gem.bff.contract.RemoveStickerPackFromProfileResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RemoveStickerPackFromProfileResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RemoveStickerPackFromProfileResponse.
 * Use `create(RemoveStickerPackFromProfileResponseSchema)` to create a new message.
 */
export const RemoveStickerPackFromProfileResponseSchema: GenMessage<RemoveStickerPackFromProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_responses, 7);
